var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgAnnouncements(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M4 5.5C4 4.94772 4.44772 4.5 5 4.5H19C19.5523 4.5 20 4.94772 20 5.5C20 6.05228 19.5523 6.5 19 6.5H5C4.44772 6.5 4 6.05228 4 5.5ZM4 9.5C4 8.94772 4.44772 8.5 5 8.5H19C19.5523 8.5 20 8.94772 20 9.5C20 10.0523 19.5523 10.5 19 10.5H5C4.44772 10.5 4 10.0523 4 9.5ZM5 12.5C4.44772 12.5 4 12.9477 4 13.5C4 14.0523 4.44772 14.5 5 14.5H19C19.5523 14.5 20 14.0523 20 13.5C20 12.9477 19.5523 12.5 19 12.5H5Z",
    fill: "#A4AAC4"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M19.9591 0C22.1855 0 24 1.81447 24 4.05067V14.9493C24 17.1855 22.1855 19 19.9591 19H19.9395V23C19.9395 23.5523 19.4918 24 18.9395 24C18.7486 24 18.5702 23.9465 18.4184 23.8537C18.3567 23.8266 18.2968 23.7929 18.2397 23.7523L11.5527 19H4.04087C1.81447 19 0 17.1855 0 14.9493V4.05067C0 1.81447 1.81447 0 4.04087 0H19.9591ZM12.2337 17.2346C12.4478 17.2346 12.6563 17.3033 12.8284 17.4306L13.5981 18L17.9395 21.0853V19.5V18.2346C17.9395 17.6823 18.3872 17.2346 18.9395 17.2346H19.9591C21.2145 17.2346 22.2346 16.2096 22.2346 14.9493L22.2346 12.8897L22.2346 12.8878V4.05067C22.2346 2.79036 21.2145 1.76543 19.9591 1.76543H4.04087C3.09931 1.76543 2.29015 2.34195 1.94442 3.16191C1.82918 3.43523 1.76543 3.73559 1.76543 4.05067L1.76543 12.8878L1.76543 12.8897V14.9493C1.76543 16.0521 2.54638 16.9747 3.58265 17.1881C3.73069 17.2186 3.88394 17.2346 4.04087 17.2346H9.5H12.2337Z",
    fill: "#A4AAC4"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAnnouncements);
export default __webpack_public_path__ + "static/media/announcements.dba209e21eb667ba225cf5f7ca72508b.svg";
export { ForwardRef as ReactComponent };